import { useRef, useState } from 'react';

import { useOnClickOutside } from '@speeki/react-hooks';

import { LanguageCode } from '@graphql/generated/graphql';

import { useReactiveVar } from '@apollo/client';
import {
    currentLanguageVar,
    translationsStatusVar,
} from '@boot/reactiveVariables';

export const useLanguageSelect = () => {
    const selectRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    useOnClickOutside(selectRef, () => setIsOpen(false));

    const translationsStatus = useReactiveVar(translationsStatusVar);
    const loading = translationsStatus === 'loading';

    const onChange = (value: string) => {
        setIsOpen(false);
        currentLanguageVar(value as LanguageCode);
    };

    const isDisabled = loading || isOpen;

    return { isDisabled, isOpen, loading, onChange, selectRef, setIsOpen };
};
